const resolveChatApiUrl = () => {
  const baseUrl =
    import.meta.env.VITE_API_BASE_URL || '';
  const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  return `${normalizedBaseUrl}splashy/v2/agents/insights/chat`;
};

export const getInsightsChatApiUrl = () => resolveChatApiUrl();